import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import MixrGroupListItem from 'srcReact/components/common2/MixrGroupListItem'
import Icon from 'srcReact/components/icons/Icon'
import Spinner from 'srcReact/components/common2/Spinner'
import { appConstantSettings } from '../../../../../appConstantSettings'

function MixrsGroupsContainer({
  type,
  screenType,
  titleCSS,
  firstName,
  commonCount,
  totalCount,
  list,
  qty,
  lastRef,
  containerRef,
  changeScreen,
  loading,
  isLoggedUser,
  groupType = 'interest'
}) {
  const isFullListPage = () => {
    return screenType === 'mixr-list' || screenType === 'interest-group-list' || screenType === 'expertise-group-list'
  }
  const { t } = useTranslation()
  const isTitleClickable = () => {
    return totalCount > appConstantSettings.MAX_GROUPS_MIXRS_DISPLAY && !isFullListPage()
  }
  return (
    <div
      className={`${styles.container} ${isFullListPage() && styles.fulllistContainer} ${
        type === 'mixr' && screenType === 'main' && styles.mixrListContainer
      }`}>
      <div className={`${styles.header} ${isFullListPage() && styles.fullListHeader}`}>
        {isFullListPage() && (
          <button onClick={() => changeScreen('main')} className={styles.back}>
            <Icon name='arrow-left24' size='large32' />
          </button>
        )}
        <button
          {...(isTitleClickable()
            ? {
                onClick: () =>
                  changeScreen(
                    `${
                      type === 'mixr'
                        ? 'mixr-list'
                        : groupType === 'expertise'
                        ? 'expertise-group-list'
                        : 'interest-group-list'
                    }`
                  )
              }
            : {})}
          className={`${styles.title} ${isTitleClickable() ? styles.clickableTitle : styles.nonClickableTitle} ${
            isFullListPage() && styles.FullListTitle
          } ${titleCSS}`}>
          {type === 'group'
            ? groupType === 'expertise' && screenType === 'main'
              ? totalCount === 1
                ? t(`profile_light.expertiseGroups_titleWithName`, { count: ` (${totalCount})`, username: firstName })
                : t(`profile_light.expertiseGroups_titleWithName_plural`, {
                    count: ` (${totalCount})`,
                    username: firstName
                  })
              : t(`profile_light.${groupType}Groups_title`, { count: totalCount })
            : ''}
          {type === 'mixr' ? t('profile_light.mixrs_title', { count: totalCount }) : ''}
        </button>
      </div>

      {list && (
        <div className={styles.list} ref={containerRef}>
          {list
            .filter((item, index) => {
              if (qty > 0) {
                return index < qty
              }
              return true
            })
            .map((item, index) => {
              const isLast = index === list.length - 1

              return (
                <MixrGroupListItem
                  groupType={groupType}
                  id={type === 'mixr' ? item.mixr_id : item.group_id}
                  picture={type === 'mixr' ? item.mixr_cover_photo : item.group_cover_photo}
                  title={type === 'mixr' ? item.mixr_name : item.group_name}
                  type={type}
                  titleCSS={styles.groupMixrTitle}
                  lastRef={isLast ? lastRef : null}
                  isCommon={item.is_common_with_logged_user}
                  groupRole={type === 'group' && item.role}
                  isPastMixr={type === 'mixr' && item.is_mixr_over === 1}
                  isLoggedUser={isLoggedUser}
                />
              )
            })}
        </div>
      )}
      {loading && <Spinner />}
    </div>
  )
}

export default MixrsGroupsContainer
